export const USER_ID = 'aJ1mpBFc80yKxmAZF';
export const SERVICE_ID = 'service_l8b2dg5';
export const TEMPLATE = {
  EMAIL_TOKEN : 'template_qlp2b9g',
  SUGESTED_TAG_APPROVED : "template_v2nmpci",
  SUGESTED_TAG_APPROVED_ADDED : "template_z5g5c0u",
  REQUESTED_GROUP_APPROVED : "template_8jy1obm",
  REFERRAL_CODE_SEND : "template_xe0928q",
  DELETED_POST : "template_laeb63x",
}